module.exports = __webpack_public_path__ + "static/img/Colla_Tale_3.b6a4161.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jobImage/jobScreenShot/Colla_Tale_3.jpg
// module id = Jv5T
// module chunks = 0